module.exports = __webpack_public_path__ + "img/34.8f6a295.webp";